export default __webpack_public_path__ + "static/media/divider.3b02e386.webp";